var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0006 18.3324L11.6616 17.6359C12.4117 16.8326 13.0864 16.0705 13.6867 15.3455L14.1822 14.7343C16.2512 12.1275 17.2863 10.0585 17.2863 8.52926C17.2863 5.26513 14.4724 2.61914 11.0006 2.61914C7.52875 2.61914 4.71484 5.26513 4.71484 8.52926C4.71484 10.0585 5.74989 12.1275 7.81894 14.7343L8.31446 15.3455C9.17083 16.3716 10.0668 17.3672 11.0006 18.3324Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0019 10.946C12.4483 10.946 13.6209 9.84952 13.6209 8.49693C13.6209 7.14434 12.4483 6.04785 11.0019 6.04785C9.5554 6.04785 8.38281 7.14434 8.38281 8.49693C8.38281 9.84952 9.5554 10.946 11.0019 10.946Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationBlack);
export default __webpack_public_path__ + "static/media/location_black.c0f38901cd67929084962a8d4536dbdf.svg";
export { ForwardRef as ReactComponent };